import { useTranslation } from "react-i18next"
import { Button } from "@/components/ui/button"
import { DialogFooter } from "@/components/ui/dialog"

type BillingDialogFooterProps = {
  onCancel: () => void
  onSave: () => void
  isLoading?: boolean
  isEditable: boolean
}

export const BillingDialogFooter = ({ isEditable, isLoading, onCancel, onSave }: BillingDialogFooterProps) => {
  const { t } = useTranslation()

  return (
    <DialogFooter>
      <Button variant="secondary" onClick={onCancel} data-testid="cancel-button">
        {t("common.button.cancel")}
      </Button>
      {isEditable && (
        <Button variant="primary" onClick={onSave} isLoading={isLoading} data-testid="save-button">
          {t("common.button.save")}
        </Button>
      )}
    </DialogFooter>
  )
}
